<template>
  <div>
    <dv-border-box-7>

      <div class="bg-color-black" style="height: 100%;">
        <div class="d-flex pt-2 pl-2" style="height:20px;">
          <div style="font-size:16px;color:#5cd9e8;float:left;padding:5px;font-size: 14px;"> 各月份交易额对比(万元)
            <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
          </div>

        </div>
        <div id="bottomCenter" style="width:98%;margin-left:2%;height:95%">

        </div>

      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
  import * as echarts from "echarts";

  export default {
    props: {


    },
    data(){
      return{
        mTime:{},
        index:0,
      }
    },
    mounted() {
      this.showData();
    },
    methods: {
      showData() {
        this.$http.get("/web/tradeData?unitCode=" + localStorage.getItem("unitCode"))
          .then((
            res) => {
            var names = [];
            var values = [];
            for (var i = 0;i< res.data.data.tradeMonthAmtList.length; i++) {
              if((res.data.data.tradeMonthAmtList[i].amount / 10000).toFixed(0)==0){
                continue;
              }
              names.push(res.data.data.tradeMonthAmtList[i].date);
              values.push((res.data.data.tradeMonthAmtList[i].amount / 10000).toFixed(0));
            }
            this.chart_line1('bottomCenter', '交易额', names, values)

          });

      },
      chart_line1(id, title, x_data, data, series) {
        var option = {
          grid: {
            left: '1%',
            right: '2%',
            top: '10%',
            bottom: '6%',
            containLabel: true
          },
          textStyle: {
            fontSize: 12,
            color: '#FFFFFF',
          },
          xAxis: {
            type: 'category',
            data: x_data
          },
          yAxis: {
            type: 'value'
          },
          legend: {
            data: data
          },
          tooltip: {  
        trigger: 'item', // 触发类型，数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用  
        formatter: '{a} <br/>{b} : {c}万元' // 提示框内容格式器，{a}、{b}、{c}、{d}分别代表系列名、数据名、数据值等  
    },
          series: [{
            name:"金额",
            data: data,
            type: 'line',
            smooth: true,  // 设置折线图平滑  
            lineStyle: {
              color: '#9fe6b8' ,// 设置线条颜色为红色
            },
            label: {  
            show: false, // 显示标签  
            position: 'top', // 标签的位置  
            formatter: '{c}' ,// 格式化标签内容，这里直接显示数值  
            color: '#32c5e9' 
        },  
            itemStyle: {
              color: '#32c5e9' // 设置线条上点的颜色为蓝色
            }
          }]
        };
        var myChart = echarts.init(document.getElementById(id));
        myChart.setOption(option);
	  

        window.addEventListener("resize", function() {
          myChart.resize();
        });
      },
    },

  }
</script>

<style lang="scss" scoped>

</style>
